module.exports = __webpack_public_path__ + "static/media/fetch.24336ade.jpg";